
import React from 'react';

import NonFSIndex from "@dndComponents/NonFSIndex";

export default function LootTableIndex() {
  return (
    <NonFSIndex
      data_type="loot_table"
    />
  );
}
